var lib_core  = require("lib-core");

var AbstractEditorController = require("./../../abstract/abstractEditorController.js");
var ImportDialogView            = require("./importDialogView.js");

var ImportDialogController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(ImportDialogController, lib_core.Controller);
ImportDialogController.inject = {
    abstractEditorController : AbstractEditorController
};

module.exports = ImportDialogController;

ImportDialogController.prototype.createView = function () {
	var editorView = this.abstractEditorController.getView();
    return new ImportDialogView(this.root,this.getStatemachine(),editorView);
};